import { instance } from '@configs/instance';
import { LoginDto, ForwardPassWordDto } from '@utils/constant/login.dto';

export const login = (body: LoginDto): Promise<any> => {
  return instance.post(
    process.env.REACT_APP_BASE_URL + `/api/v1/staff/login`,
    body,
  );
};

export const forwardPassword = (body: any): Promise<any> => {
  return instance.post(
    process.env.REACT_APP_BASE_URL + `/api/v1/staff/send-sms`,
  );
};

export const sendSMS = (body: any): Promise<any> => {
  return instance.post(
    process.env.REACT_APP_BASE_URL + `/api/v1/staff/send-sms`,
    body,
  );
};

export const verifyOTP = (body: any): Promise<any> => {
  return instance.post(
    process.env.REACT_APP_BASE_URL + `/api/v1/staff/verify-phone`,
    body,
  );
};

export const changePassword = (body: any, token: string): Promise<any> => {
  return instance.post(
    process.env.REACT_APP_BASE_URL + `/api/v1/staff/reset-password`,
    body,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
};
